import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { CasingsPage } from '../../CasingsPage'
import { editorSearchSchema } from '../search-schemas'

// /casings — список + редактор. Открытие редактора через search-параметры
// (?edit=N или ?new=1), не отдельные роуты — чтобы не размонтировать список
// (resource items, filterText) при переключении list↔editor.
// new имеет приоритет над edit (если оба заданы — открываем форму создания).
export const casingsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/casings',
  validateSearch: editorSearchSchema,
  component: CasingsRouteComponent,
})

function CasingsRouteComponent() {
  const search = casingsRoute.useSearch()
  const navigate = useNavigate()
  return (
    <CasingsPage
      casingId={search().edit ?? null}
      create={search().new === 1}
      onOpen={(id) => navigate({ to: '/casings', search: { edit: id } })}
      onCreate={() => navigate({ to: '/casings', search: { new: 1 } })}
      onBack={() => navigate({ to: '/casings', search: {} })}
    />
  )
}
